export const defaultValue = {
	next: undefined,
	previous: undefined,
};
